export const LEAD_CACHE_KEY = 'LEAD_CACHE_KEY';
export const LEAD_ID_STORAGE_KEY = 'LEAD_ID_STORAGE_KEY';
